module.exports = __webpack_public_path__ + "img/floor-plan.cb93e0d0.svg";